import InsightsPage from '../pages/insights-page.vue'

export default [
  {
    component: InsightsPage,
    name: 'insights',
    path: '/:slug/insights',
  },
]
